import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
    state:{
        courseId:'',//课程id
        userName:'',//用户名
        userAvatar:'',//用户头像
        schoolName:'',//学校名
        roleName:'',//用户身份
        phone:'',//手机号
        workNumber:'',//学号
        routerPath:'/index',
        content:'',
        pageId:0
    },
    mutations:{
        //保存页面模块id
        setPageId(state, payload) {
            state.pageId = payload.pageId
        },

        //是否是重置的默认密码0否1是
        rememberKey (state, payload) {
            state.isDefaultPassword = payload.isDefaultPassword
        },
        
        //保存修改内容
        setNoticeContent(state, payload){
            state.content = payload.content
        },

        //侧边栏目导航
        setRouterPath(state, payload){
            state.routerPath = payload.routerPath
        },
        
        //登录时获取用户信息
        setUserInfo(state, payload){
            state.schoolName = payload.schoolName
            state.roleName = payload.roleName
            state.phone = payload.phone
            state.workNumber = payload.workNumber
            state.userName = payload.userName
        },

        //修改用户头像
        setUserAvatar(state, payload){
            state.userAvatar = payload.userAvatar
        },

        //保存课程id
        setCourseId(state, payload){
            state.courseId = payload.courseId
        }
    },
        
    getters:{
    
    },
    
    actions:{
    
    },
})
export default store;